export enum PropertyStatus {
  IMPORTED = 'IMPORTED',
  RESERVED = 'RESERVED',
  DEFAULT = 'DEFAULT'
}
